/**
 * Created by Julio Perez on 9/20/2016.
 */
// import angular from 'angular';
// import uirouter from 'angular-ui-router';

import routing from './nav-links-strip.routes';
import NavLinksStripController from './nav-links-strip.controller';
import navLinksStrip from './nav-links-strip.directive';
import navLinksStripService from './nav-links-strip.service';
import mapLeafletService from '../../views/map-page/map.leaflet';

// import scr from "../../shared/js/html-screenshot";

export default angular
    .module('navLinksStrip', [
        // uirouter,
        navLinksStrip,
        navLinksStripService,
        mapLeafletService
        // scr
    ])
    .config(routing)
    .controller('NavLinksStripController', NavLinksStripController)
    .name;


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-strip/index.js